"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _styledComponents = require("styled-components");

var _reactRouterDom = require("react-router-dom");

var _reactResponsive = require("react-responsive");

var _Icon = _interopRequireDefault(require("../../../Icon"));

var _theme = require("../../../Themes/theme");

var _Popover = require("../../../Popover");

var _About = _interopRequireDefault(require("./views/About"));

var _Footer = _interopRequireDefault(require("./components/Footer"));

var _Grid = _interopRequireDefault(require("./components/Grid"));

var _Topnav = _interopRequireDefault(require("./components/Topnav"));

var _Contact = _interopRequireDefault(require("../../common/Contact"));

var _TermsOfUse = _interopRequireDefault(require("../../common/TermsOfUse"));

var _Elements = require("../../Elements");

var _Elements2 = require("./Elements");

var _PrivacyPolicy = _interopRequireDefault(require("../../common/PrivacyPolicy"));

var _constants = require("../../constants/constants");

var _helpers = require("../../common/helpers");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react-hooks/exhaustive-deps */
var Moodie = function Moodie(_ref) {
  var _portfolio$user, _portfolio$location, _portfolio$location2, _portfolio$folders, _portfolio$folders$fi, _portfolio$user2, _portfolio$location3, _portfolio$user3, _portfolio$termsOfUse, _portfolio$privacyPol;

  var scrollDomId = _ref.scrollDomId,
      portfolio = _ref.portfolio,
      onSubmitMessage = _ref.onSubmitMessage,
      webpSupported = _ref.webpSupported;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      aboutOffsetTop = _useState2[0],
      setAboutOffsetTop = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      layoutWidth = _useState4[0],
      setLayoutWidth = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      contactOffsetTop = _useState6[0],
      setContactOffsetTop = _useState6[1];

  var _useState7 = (0, _react.useState)(-1),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      selectedFolder = _useState8[0],
      setSelectedFolder = _useState8[1]; // -1 -> "all", 0, 1, 2, ... -> "folder index"


  var triggerRef = (0, _react.useRef)(null);
  var aboutRef = (0, _react.useRef)(null);
  var contactRef = (0, _react.useRef)(null);
  var isTabletLandScape = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1024px)'
  });
  var isTabletPortrait = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 768px)'
  });
  var isMobileLandScape = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 667px)'
  });

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      overflowVisibility = _useState10[0],
      setOverflowVisibility = _useState10[1];

  var _useState11 = (0, _react.useState)(1),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      currentLoadTimes = _useState12[0],
      setCurrentLoadTimes = _useState12[1];

  var _useRouteMatch = (0, _reactRouterDom.useRouteMatch)(),
      url = _useRouteMatch.url;

  var publicUrl = url === '/' ? '' : url;
  var baseUrl = "".concat(portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$user = portfolio.user) === null || _portfolio$user === void 0 ? void 0 : _portfolio$user.username, ".").concat(process.env.REACT_APP_PORTFOLIO_HOST);
  var tosUrl = (0, _helpers.generateTosUrl)(portfolio, publicUrl);
  var policyUrl = (0, _helpers.generatePolicyUrl)(portfolio, publicUrl);
  var coverPhotoUrl = (0, _helpers.getCoverPhotoUrl)(portfolio === null || portfolio === void 0 ? void 0 : portfolio.coverPhoto);
  var userLocationData = [portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$location = portfolio.location) === null || _portfolio$location === void 0 ? void 0 : _portfolio$location.city, portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$location2 = portfolio.location) === null || _portfolio$location2 === void 0 ? void 0 : _portfolio$location2.country];
  var location = userLocationData.filter(function (val) {
    return val;
  }).join(', ');
  var topnavPadding = (0, _react.useMemo)(function () {
    if (isTabletLandScape) {
      return 48;
    }

    if (isTabletPortrait) {
      return 24;
    }

    return 16;
  }, [isTabletLandScape, isTabletPortrait, isMobileLandScape]); // Exclude null and empty folders

  var folders = (portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$folders = portfolio.folders) === null || _portfolio$folders === void 0 ? void 0 : (_portfolio$folders$fi = _portfolio$folders.filter) === null || _portfolio$folders$fi === void 0 ? void 0 : _portfolio$folders$fi.call(_portfolio$folders, function (folder) {
    var _folder$photos, _folder$photos$edges;

    return folder && ((_folder$photos = folder.photos) === null || _folder$photos === void 0 ? void 0 : (_folder$photos$edges = _folder$photos.edges) === null || _folder$photos$edges === void 0 ? void 0 : _folder$photos$edges.length) > 0;
  })) || []; // Probably expensive enough to memoize
  // FIXME(Pavel): see if its possible to just pass this into GridModal

  var allPhotos = (0, _react.useMemo)(function () {
    return folders.reduce(function (acc, folder) {
      var _folder$photos2;

      var photos = (folder === null || folder === void 0 ? void 0 : (_folder$photos2 = folder.photos) === null || _folder$photos2 === void 0 ? void 0 : _folder$photos2.edges) || [];
      var newPhotos = photos.map(function (photo) {
        if (photo !== null && photo !== void 0 && photo.node) {
          var _photo$node, _photo$node2, _photo$node3, _photo$node3$images, _photo$node4, _photo$node5;

          return {
            folderId: folder === null || folder === void 0 ? void 0 : folder.id,
            id: photo === null || photo === void 0 ? void 0 : photo.node.id,
            // Use UID id instead of non-unique legacyId
            height: photo === null || photo === void 0 ? void 0 : (_photo$node = photo.node) === null || _photo$node === void 0 ? void 0 : _photo$node.height,
            width: photo === null || photo === void 0 ? void 0 : (_photo$node2 = photo.node) === null || _photo$node2 === void 0 ? void 0 : _photo$node2.width,
            url: photo === null || photo === void 0 ? void 0 : (_photo$node3 = photo.node) === null || _photo$node3 === void 0 ? void 0 : (_photo$node3$images = _photo$node3.images) === null || _photo$node3$images === void 0 ? void 0 : _photo$node3$images[0].url,
            name: photo === null || photo === void 0 ? void 0 : (_photo$node4 = photo.node) === null || _photo$node4 === void 0 ? void 0 : _photo$node4.name,
            descirption: photo === null || photo === void 0 ? void 0 : (_photo$node5 = photo.node) === null || _photo$node5 === void 0 ? void 0 : _photo$node5.description
          };
        }

        return null;
      });
      return [].concat((0, _toConsumableArray2["default"])(acc), (0, _toConsumableArray2["default"])(newPhotos));
    }, []);
  }, [folders]);
  var selectedPhotos = selectedFolder === -1 ? allPhotos : allPhotos.filter(function (photo) {
    return photo.folderId === folders[selectedFolder].id;
  });
  var maxLoadTimes = (0, _react.useMemo)(function () {
    return Math.ceil(selectedPhotos.length / 20);
  }, [selectedPhotos]); // eslint-disable-next-line arrow-body-style

  var displayLayoutPhotos = (0, _react.useMemo)(function () {
    return selectedPhotos.slice(0, currentLoadTimes * 20);
  }, [currentLoadTimes, selectedPhotos]);
  var folderDescription = (0, _react.useMemo)(function () {
    if (folders.length === 1) {
      return folders[0].description;
    }

    return selectedFolder === -1 ? undefined : folders[selectedFolder].description;
  }, [selectedFolder]);
  (0, _react.useEffect)(function () {
    var _aboutRef$current;

    if (aboutRef !== null && aboutRef !== void 0 && (_aboutRef$current = aboutRef.current) !== null && _aboutRef$current !== void 0 && _aboutRef$current.offsetTop) {
      var _aboutRef$current2, _contactRef$current;

      setAboutOffsetTop(aboutRef === null || aboutRef === void 0 ? void 0 : (_aboutRef$current2 = aboutRef.current) === null || _aboutRef$current2 === void 0 ? void 0 : _aboutRef$current2.offsetTop);
      setContactOffsetTop(contactRef === null || contactRef === void 0 ? void 0 : (_contactRef$current = contactRef.current) === null || _contactRef$current === void 0 ? void 0 : _contactRef$current.offsetTop);
    }

    window.addEventListener('resize', function () {
      var _aboutRef$current3;

      if (aboutRef !== null && aboutRef !== void 0 && (_aboutRef$current3 = aboutRef.current) !== null && _aboutRef$current3 !== void 0 && _aboutRef$current3.offsetTop) {
        var _aboutRef$current4, _contactRef$current2;

        setAboutOffsetTop(aboutRef === null || aboutRef === void 0 ? void 0 : (_aboutRef$current4 = aboutRef.current) === null || _aboutRef$current4 === void 0 ? void 0 : _aboutRef$current4.offsetTop);
        setContactOffsetTop(contactRef === null || contactRef === void 0 ? void 0 : (_contactRef$current2 = contactRef.current) === null || _contactRef$current2 === void 0 ? void 0 : _contactRef$current2.offsetTop);
      }
    });
  }, []);
  (0, _react.useEffect)(function () {
    setCurrentLoadTimes(1);
  }, [selectedFolder]);
  (0, _react.useEffect)(function () {
    var _aboutRef$current5;

    if (aboutRef !== null && aboutRef !== void 0 && (_aboutRef$current5 = aboutRef.current) !== null && _aboutRef$current5 !== void 0 && _aboutRef$current5.offsetTop) {
      var _aboutRef$current6, _contactRef$current3;

      setAboutOffsetTop(aboutRef === null || aboutRef === void 0 ? void 0 : (_aboutRef$current6 = aboutRef.current) === null || _aboutRef$current6 === void 0 ? void 0 : _aboutRef$current6.offsetTop);
      setContactOffsetTop(contactRef === null || contactRef === void 0 ? void 0 : (_contactRef$current3 = contactRef.current) === null || _contactRef$current3 === void 0 ? void 0 : _contactRef$current3.offsetTop);
    }
  }, [selectedFolder, currentLoadTimes]);

  var folderMenu = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Elements2.FolderBox, {
    key: "portfolio-folder-all",
    px: "sm",
    mb: "sm",
    pointer: true,
    onClick: function onClick() {
      setSelectedFolder(-1);
      setOverflowVisibility(false);
    },
    colour: _constants.PORTFOLIO_THEME_COLOR[portfolio === null || portfolio === void 0 ? void 0 : portfolio.colour]
  }, /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    bold: selectedFolder === -1,
    fontColor: selectedFolder === -1 && _constants.PORTFOLIO_THEME_COLOR[portfolio.colour],
    portfolioForeground2: selectedFolder !== -1
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.moodie.folders.all"
  }))), folders.map(function (folder, index) {
    return /*#__PURE__*/_react["default"].createElement(_Elements2.FolderBox, {
      key: folder === null || folder === void 0 ? void 0 : folder.id,
      px: "sm",
      mb: "sm",
      pointer: true,
      onClick: function onClick() {
        setSelectedFolder(index);
        setOverflowVisibility(false);
      },
      colour: _constants.PORTFOLIO_THEME_COLOR[portfolio.colour]
    }, /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
      bold: selectedFolder === index,
      fontColor: selectedFolder === index && _constants.PORTFOLIO_THEME_COLOR[portfolio.colour],
      portfolioForeground2: selectedFolder !== index
    }, folder.name));
  }));

  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: (0, _theme.configPortfolioTheme)(portfolio.appearance.toLocaleLowerCase(), _constants.PORTFOLIO_THEME_FONTFAMILY[portfolio.font])
  }, /*#__PURE__*/_react["default"].createElement(_Elements2.MoodieBox, {
    id: "portfolio-theme-moodie"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react["default"].createElement(_Topnav["default"], {
    publicUrl: publicUrl,
    aboutTop: aboutOffsetTop,
    contactTop: contactOffsetTop,
    websiteName: portfolio.title,
    visibilityOptions: portfolio === null || portfolio === void 0 ? void 0 : portfolio.visibilityOptions,
    socialMedia: portfolio === null || portfolio === void 0 ? void 0 : portfolio.socialMedia,
    username: portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$user2 = portfolio.user) === null || _portfolio$user2 === void 0 ? void 0 : _portfolio$user2.username,
    scrollDomId: scrollDomId,
    colour: portfolio === null || portfolio === void 0 ? void 0 : portfolio.colour,
    layoutWidth: layoutWidth
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(publicUrl, "/terms")
  }, /*#__PURE__*/_react["default"].createElement(_TermsOfUse["default"], {
    siteTitle: portfolio === null || portfolio === void 0 ? void 0 : portfolio.title,
    activeSiteUrl: baseUrl,
    userCountry: (portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$location3 = portfolio.location) === null || _portfolio$location3 === void 0 ? void 0 : _portfolio$location3.country) || 'Canada',
    smallHeader: true
  })), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(publicUrl, "/policy")
  }, /*#__PURE__*/_react["default"].createElement(_PrivacyPolicy["default"], {
    siteTitle: portfolio === null || portfolio === void 0 ? void 0 : portfolio.title,
    smallHeader: true
  })), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(publicUrl)
  }, folders.length > 1 && /*#__PURE__*/_react["default"].createElement(_Elements2.FolderWrapper, {
    padding: topnavPadding,
    width: layoutWidth,
    fontColor: _constants.PORTFOLIO_THEME_COLOR[portfolio.colour]
  }, /*#__PURE__*/_react["default"].createElement(_Popover.Popover, {
    id: "portfolio-moodie-popover",
    render: folderMenu,
    triggerRef: triggerRef,
    onClickout: function onClickout() {
      return setOverflowVisibility(false);
    },
    triggerShow: function triggerShow() {
      return setOverflowVisibility(true);
    },
    popoverNestedRole: "dialog",
    alignment: "flex-end",
    position: "bottom-left",
    width: 174,
    show: overflowVisibility
  }, /*#__PURE__*/_react["default"].createElement(_Elements2.FolderDropdownBox, {
    flex: true,
    align: "center",
    triggerRef: triggerRef,
    onClick: function onClick() {
      setOverflowVisibility(!overflowVisibility);
    },
    pointer: true,
    padding: topnavPadding
  }, /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    fontColor: _constants.PORTFOLIO_THEME_COLOR[portfolio.colour],
    mr: "xs",
    bold: true
  }, selectedFolder === -1 ? 'All' : folders[selectedFolder].name), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    svg: "chevronDown",
    size: "xs"
  })))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    title: portfolio.title,
    photos: displayLayoutPhotos,
    description: folderDescription,
    folders: folders,
    setLayoutWidth: setLayoutWidth,
    layoutWidth: layoutWidth,
    onLoadMore: function onLoadMore() {
      setCurrentLoadTimes(function (prevState) {
        return prevState + 1;
      });
    },
    currentLoadTimes: currentLoadTimes,
    maxLoadTimes: maxLoadTimes,
    colour: portfolio === null || portfolio === void 0 ? void 0 : portfolio.colour,
    webpSupported: webpSupported
  }), /*#__PURE__*/_react["default"].createElement(_Elements2.AboutBox, {
    ref: aboutRef
  }, /*#__PURE__*/_react["default"].createElement(_About["default"], {
    cover: coverPhotoUrl,
    description: portfolio.description,
    location: location
  })), /*#__PURE__*/_react["default"].createElement(_Elements2.ContactBox, {
    ref: contactRef
  }, /*#__PURE__*/_react["default"].createElement(_Contact["default"], {
    centerSendEmailBtn: true,
    colour: portfolio === null || portfolio === void 0 ? void 0 : portfolio.colour,
    onSubmitMessage: onSubmitMessage
  })))), /*#__PURE__*/_react["default"].createElement(_Footer["default"], {
    tosUrl: tosUrl,
    policyUrl: policyUrl,
    name: portfolio.title,
    visibilityOptions: portfolio === null || portfolio === void 0 ? void 0 : portfolio.visibilityOptions,
    socialMedia: portfolio === null || portfolio === void 0 ? void 0 : portfolio.socialMedia,
    username: portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$user3 = portfolio.user) === null || _portfolio$user3 === void 0 ? void 0 : _portfolio$user3.username,
    colour: portfolio === null || portfolio === void 0 ? void 0 : portfolio.colour,
    isCustomTos: !!(portfolio !== null && portfolio !== void 0 && (_portfolio$termsOfUse = portfolio.termsOfUse) !== null && _portfolio$termsOfUse !== void 0 && _portfolio$termsOfUse.url),
    isCustomPolicy: !!(portfolio !== null && portfolio !== void 0 && (_portfolio$privacyPol = portfolio.privacyPolicy) !== null && _portfolio$privacyPol !== void 0 && _portfolio$privacyPol.url)
  }))));
};

Moodie.defaultProps = {
  onSubmitMessage: function onSubmitMessage() {},
  scrollDomId: '',
  webpSupported: false
};
Moodie.propTypes = {
  portfolio: _propTypes["default"].shape({
    title: _propTypes["default"].string,
    status: _propTypes["default"].oneOf(['ONBOARDING', 'ACTIVE', 'INACTIVE']),
    description: _propTypes["default"].string,
    appearance: _propTypes["default"].string,
    font: _propTypes["default"].string,
    folders: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
    colour: _propTypes["default"].string.isRequired,
    coverPhoto: _propTypes["default"].shape({
      photo: _propTypes["default"].shape({
        images: _propTypes["default"].arrayOf(_propTypes["default"].shape())
      })
    }),
    socialMedia: _propTypes["default"].shape({
      instagram: _propTypes["default"].string,
      facebook: _propTypes["default"].string,
      twitter: _propTypes["default"].string
    }),
    location: _propTypes["default"].shape({
      country: _propTypes["default"].string,
      city: _propTypes["default"].string
    }),
    user: _propTypes["default"].shape({
      username: _propTypes["default"].string
    }),
    visibilityOptions: _propTypes["default"].shape({
      pxProfile: _propTypes["default"].string
    }),
    termsOfUse: _propTypes["default"].shape({
      url: _propTypes["default"].string
    }),
    privacyPolicy: _propTypes["default"].shape({
      url: _propTypes["default"].string
    })
  }).isRequired,
  onSubmitMessage: _propTypes["default"].func,
  scrollDomId: _propTypes["default"].string,
  webpSupported: _propTypes["default"].bool
};
var _default = Moodie;
exports["default"] = _default;